(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flossy-design"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', event => {
  if(event.key === 'Escape') document.querySelectorAll('.fx-menu[open], .fx-localization[open]').forEach(el => {el.open=false;el.querySelector('summary').focus();});
});
document.addEventListener('click', event => {
  document.querySelectorAll('.fx-menu[open]').forEach(el => {if(!el.contains(event.target)) el.open=false;});
});
let flossyStickyFrame;
function updateFlossySticky(){
  flossyStickyFrame=null;
  const bar=document.querySelector('.fx-sticky-buy');
  const button=document.querySelector('.product-form__submit');
  const footer=document.querySelector('.fx-footer');
  if(!bar||!button)return;
  const pastButton=button.getBoundingClientRect().bottom<0;
  const beforeFooter=!footer||footer.getBoundingClientRect().top>window.innerHeight+Math.max(bar.offsetHeight,96);
  const consent=Array.from(document.querySelectorAll('.shopify-pc__banner__dialog,.shopify-pc__prefs__dialog')).some(panel=>panel.getBoundingClientRect().height>0&&getComputedStyle(panel).visibility!=='hidden');
  const visible=pastButton&&beforeFooter&&!consent;
  if(bar.classList.contains('is-visible')!==visible)bar.classList.toggle('is-visible',visible);
}
function scheduleFlossySticky(){
  if(!flossyStickyFrame)flossyStickyFrame=requestAnimationFrame(updateFlossySticky);
}
window.addEventListener('scroll',scheduleFlossySticky,{passive:true});
window.addEventListener('resize',scheduleFlossySticky);
document.addEventListener('click',scheduleFlossySticky);
document.addEventListener('load',scheduleFlossySticky,true);
document.addEventListener('shopify:section:load',scheduleFlossySticky);
function initFlossySticky(){
  scheduleFlossySticky();
  if(document.querySelector('.fx-sticky-buy'))new MutationObserver(scheduleFlossySticky).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','hidden','open']});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFlossySticky);else initFlossySticky();
document.addEventListener('click',event=>{
  const link=event.target.closest('.fx-mobile-panel a');
  if(link)link.closest('details').open=false;
});
  } catch(e) { console.error(e); }
})();

})();
